import { DoubleSide, MeshPhysicalMaterial } from 'three';
import { Loader } from '../utils/Loader';

export enum PredefinedMaterialType {
	GLASS = 'glass',
	HIDDEN = 'hidden',
}

export class PredefinedMaterialFactory {
	private loader = Loader.getInstance();
	private static instance: PredefinedMaterialFactory;

	private constructor() {}

	static getInstance() {
		if (!PredefinedMaterialFactory.instance)
			PredefinedMaterialFactory.instance = new PredefinedMaterialFactory();
		return PredefinedMaterialFactory.instance;
	}

	getMaterial(type: PredefinedMaterialType) {
		switch (type) {
			case PredefinedMaterialType.GLASS:
				return this.getGlassMaterial();
			default:
				throw new Error('UNKNOWN_PREDEFINED_MATERIAL_TYPE');
		}
	}

	private getGlassMaterial() {
		const material = new MeshPhysicalMaterial({
			color: 0xf5faff,
			metalness: 0,
			roughness: 0.01,
			transmission: 1,
			transparent: true,
			opacity: 1,
			ior: 1.5,
			thickness: 0,
			specularIntensity: 1,
			envMapIntensity: 1,
			side: DoubleSide,
			depthWrite: false,
		});

		return material;
	}
}
